import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import portfolioData from './data/portfolio.json';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState(portfolioData.projects);
  const [experiences, setExperiences] = useState(portfolioData.experiences);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    // Force dark mode
    document.documentElement.classList.add('dark');

    return () => clearTimeout(timer);
  }, []);

  const handleUpdateProjects = (updatedProjects: any[]) => {
    setProjects(updatedProjects);
    // In a real app, you would save to a database here
    console.log('Projects updated:', updatedProjects);
  };

  const handleUpdateExperiences = (updatedExperiences: any[]) => {
    setExperiences(updatedExperiences);
    // In a real app, you would save to a database here
    console.log('Experiences updated:', updatedExperiences);
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen bg-dark-900 text-white">
      <Header 
        profile={portfolioData.profile}
        projects={projects}
        experiences={experiences}
        onUpdateProjects={handleUpdateProjects}
        onUpdateExperiences={handleUpdateExperiences}
      />
      
      <main>
        <Hero profile={portfolioData.profile} />
        <About profile={portfolioData.profile} />
        <Experience experiences={experiences} />
        <Projects projects={projects} />
        <Skills skills={portfolioData.skills} />
        <Contact profile={portfolioData.profile} />
      </main>
      
      <Footer profile={portfolioData.profile} />
    </div>
  );
}

export default App;
